// components
import BackToTop from '../../../components/BackToTop';
import Hero from './Hero';
// dummy data
import { benefits, gallery, vacancies, features } from './data';
import Features from './Features';

const Career = () => {
    return (
        <>
            <Hero />
            <Features features={features} />
            <BackToTop />
        </>
    );
};

export default Career;
